import { Profiler } from 'react'
import type { FC, ProfilerOnRenderCallback, ReactNode } from 'react'

import { THEME_PERF_ENABLED, recordCommit } from 'lib/themePerf'

// Measurement-only: wraps the themed subtree in React.Profiler so a theme swap's
// commit count + actualDuration can be captured. When GATSBY_PROFILE is off the
// children render directly (just a Fragment) with zero Profiler overhead.

const onRender: ProfilerOnRenderCallback = (_id, _phase, actualDuration) => {
  recordCommit(actualDuration)
}

const ThemePerfProfiler: FC<{ children: ReactNode }> = ({ children }) =>
  THEME_PERF_ENABLED ? (
    <Profiler id="theme-tree" onRender={onRender}>
      {children}
    </Profiler>
  ) : (
    <>{children}</>
  )

export default ThemePerfProfiler
